<template>
  <div>
    <div class="boxShell">
      <i class="iconfont icon-chenggong-icon topicon"></i>
      <p class="tip">恭喜您，审核通过</p>
      <Button
        :text="draw"
        :type="danger"
        class="nextStep"
        :click="goToNextPage"
      />
    </div>
  </div>
</template>
<script>
import Button from '@/components/Button.vue';
import { checkStatus } from './mixin';

export default {
  name: 'IdentifySuccess',
  data() {
    return {
      danger: 'danger',
      draw: '下一步',
    };
  },
  mixins: [checkStatus],
  components: {
    Button,
  },
  methods: {
    goToNextPage() {
      this.$store.dispatch('commonForms/nextJumpPage', {
        orderId: localStorage.getItem('orderId'),
      });
    },
  },
};
</script>
<style scoped>
.boxShell {
  padding-top: 103px;
}
.topicon {
  margin-top: 103px;
  color: #ff6538;
  font-size: 60px;
}
.tip {
  color: #1c2438;
  font-size: 17px;
  text-align: center;
}
.nextStep {
  margin-top: 100px;
  margin-bottom: 7px;
}
</style>
